export default __webpack_public_path__ + "static/icon1-78ca55d2360a64735b9b2b1aa5be6b09.svg";